import React, { FC } from 'react'
import { Link } from '@mui/material'

const CUSTOMER_SUPPORT_NUMBER_WITH_TEXT = '1-844-55-BRIGHT'
const CUSTOMER_SUPPORT_NUMBER = '1-844-552-7444'

const CustomerSupportNumber: FC = () => (
  <>
    <Link href={`tel: ${CUSTOMER_SUPPORT_NUMBER}`} className="no-wrap">
      {CUSTOMER_SUPPORT_NUMBER_WITH_TEXT}
    </Link>{' '}
    <Link href={`tel: ${CUSTOMER_SUPPORT_NUMBER}`} className="no-wrap">
      ({CUSTOMER_SUPPORT_NUMBER})
    </Link>
  </>
)

export default CustomerSupportNumber
